import Axios from 'axios';

const LOGIN_URL = '/users/login';
const RETURN_TO_KEY = 'returnTo';

const axios = Axios.create({
    baseURL: '/',
    headers: {
        Accept: 'application/json',
        "Content-Type": 'application/json',
        "X-CSRF-Token": window.csrfToken
    }
});

/**
 * Whether a failed request means the login session is gone (see
 * App\Middleware\ApiAuthFailureMiddleware).
 */
export function isSessionExpired(error) {
    const response = error.response;
    if (!response) {
        return false;
    }

    return response.status === 401
        || (response.status === 403 && response.data?.error === 'csrf_token_invalid');
}

/**
 * The hash route the user was on when the session expired, consumed once.
 */
export function takeReturnTo() {
    let hash;
    try {
        hash = sessionStorage.getItem(RETURN_TO_KEY);
        sessionStorage.removeItem(RETURN_TO_KEY);
    } catch (e) {
        return null;
    }

    return hash && hash.startsWith('#/') ? hash : null;
}

let redirectingToLogin = false;

/**
 * Whether the browser is on its way to the login page because the session
 * expired — a page warning about leaving should let that navigation through.
 */
export function isRedirectingToLogin() {
    return redirectingToLogin;
}

// A lost session is not a technical error: send the browser to the login page
// instead of showing the generic error modal, remembering where to come back to.
axios.interceptors.response.use(null, error => {
    if (!isSessionExpired(error)) {
        return Promise.reject(error);
    }

    if (!redirectingToLogin) {
        redirectingToLogin = true;
        try {
            if (!window.location.pathname.startsWith(LOGIN_URL)) {
                sessionStorage.setItem(RETURN_TO_KEY, window.location.hash);
            }
        } catch (e) {
            // sessionStorage can be unavailable; returning to the route is a nicety
        }
        window.location.href = `${LOGIN_URL}?expired=1`;
    }

    // Deliberately never settles: while the browser navigates away, no error
    // modal should pop up and no caller's .catch() should run.
    return new Promise(() => {});
});

export default axios
